import { TableBody, TableRow, TableCell, TextField } from '@mui/material'
import React from 'react'
import { Button } from 'react-admin'
import { entries } from 'services/utils'
import CopyToClipboard from 'ui-shared/CopyToClipboard'
import { I18nMap } from './I18nFileProvider'
import { DeleteLabelFn, UpdateTranslationFn } from './I18nFormHandler'

type Props = {
  labelsToRender: string[]
  i18nMap: I18nMap
  updateTranslation: UpdateTranslationFn
  deleteLabel: DeleteLabelFn
  isDeleteEnabled: boolean
}

const I18nLabelsForm: React.FC<Props> = ({
  i18nMap,
  labelsToRender,
  updateTranslation,
  deleteLabel,
  isDeleteEnabled,
}) => {
  return (
    <TableBody>
      {labelsToRender.map((key, idx) => (
        <TableRow key={idx}>
          <TableCell style={{ width: '20%' }}>
            <div
              style={{
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center',
              }}
            >
              <CopyToClipboard
                text={key}
                label="tooltip.i18n.copyLabelToClipboard"
                notificationLabel="notification.info.labelCopiedToClipboard"
              />
              <span>{key}</span>
            </div>
          </TableCell>
          {entries(i18nMap).map(([code, json], index) => (
            <TableCell key={index + 100}>
              <TextField
                value={json[key]}
                onChange={updateTranslation(key, code)}
                variant="outlined"
                size="small"
                fullWidth
              />
            </TableCell>
          ))}
          {isDeleteEnabled && (
            <TableCell style={{ width: '1%' }}>
              <Button label="X" onClick={() => deleteLabel(key)} />
            </TableCell>
          )}
        </TableRow>
      ))}
    </TableBody>
  )
}

export default I18nLabelsForm
